const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Delays the load of YouTube embedded videos
 * Will wait unitl the video is in the viewport
 */
const VideoViewport = {

    init() { 

        $.fn.isInViewport = function() {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).outerHeight();
          
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
          
            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

          $(window).on('resize scroll', function() {
            $('.guard-video').each(function() {
                
                var videoUrl = $(this).attr('data-url');
                
                if ($(this).isInViewport() && !$(this).attr("src")) {

                    $(this).attr("src", videoUrl ); 
                }
            });
          });
    }
};

export default VideoViewport;